import { graphql } from 'react-apollo';
import compose from 'lodash.flowright';
import { withRouter } from 'react-router-dom';

import { MeQuery } from '../../graphql/queries/account';
import {
  accountUpdate,
  accountAddProRoles,
} from '../../graphql/mutations/account';
import AccountSetupForm from '../../components/auth/AccountSetup';

const withUserData = graphql(MeQuery, {
  props: ({ data }) => ({
    loading: data.loading,
    error: data.error,
    user: data.me,
  }),
});

const withAccountAddProRolesMutation = graphql(accountAddProRoles, {
  props: ({ mutate }) => ({
    addProRoles: (userId, roles) =>
      mutate({
        variables: {
          input: {
            account_id: userId,
            roles,
          },
        },
      }),
  }),
});

const withAccountUpdateMutation = graphql(accountUpdate, {
  props: ({ mutate }) => ({
    updateAccount: account =>
      mutate({
        variables: {
          input: account,
        },
      }),
  }),
});

export default compose(
  withUserData,
  withAccountUpdateMutation,
  withAccountAddProRolesMutation,
  withRouter,
)(AccountSetupForm);
